export const BUSINESS_QUERY_KEY = 'business';
